import { useFiltersStore } from "@/store/useFiltersStore";
import { ProjectsList } from "../ProjectsList/ProjectsList";
import { GallerySliderModal } from "../../GallerySliderModal/GallerySliderModal";
import { TImageAsset, TVideoAsset } from "@/types/global";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ProjectsLoader } from "../ProjectsLoader/ProjectsLoader";
import { NoProjectsFound } from "../NoProjectsFound/NoProjectsFound";
import * as Styled from "./ImagesWithProjectsList.styled";
import { ArchivedProjectsGallery } from "../ArchivedProjectsGallery/ArchivedProjectsGallery";


export const ImagesWithProjectsList = ()=> {

  const [isMounted, setIsMounted] = useState(false);
  const isCurrentlyFetchingProjects = useFiltersStore((state) => state.isCurrentlyFetchingProjects);

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const imagesWithProjects = useFiltersStore(
    (state) => state.imagesWithProjects
  );

  const getGalleryAssets = (): (TImageAsset | TVideoAsset)[] => {
    return (imagesWithProjects || [])
      .map((item) => {
        if (item.image) return item.image as TImageAsset;
        if (item.video) return item.video as TVideoAsset;
        return undefined;
      })
      .filter((asset): asset is TImageAsset | TVideoAsset => asset !== undefined);
   }

  const getGalleryAssetsData = () => {
    return (imagesWithProjects || [])
      .map((item) => {
        return {
          projectSlug: item.slug || '',
          projectTitle: item.title || '',
          imageSrc: item.image 
            ? process.env.NEXT_PUBLIC_ADMIN_URL + '/admin/files/' + item.image?.src.split('/').pop()
            : item.video ? process.env.NEXT_PUBLIC_ADMIN_URL + '/admin/content/Videos/' + item.video.directusId : '',
        }
      });
   }

  const galleryModal = isMounted && typeof window !== 'undefined'
    ? createPortal(
      <GallerySliderModal 
        medias={getGalleryAssets()} 
        title="Images"
        assetsWithProjectsData={getGalleryAssetsData() || []}
        playsVideosInline={false}
      />,
      document.getElementById('modal-navigation-alert-root')!
  ) : null

  return (
    <>
      <Styled.ImagesWithProjectsListContainer className="images-with-projects-list-container">
          <ProjectsList
            projectList={{projects: isCurrentlyFetchingProjects ? [] 
              : imagesWithProjects && imagesWithProjects.filter((item) => !item.archived) || [], 
            }}
            numProjectsToShow={500}
            isPrivatePresentation={false}
            isSpecificWorkPage={true}
            isImagesWithProjects={true}
          />
          {
            !isCurrentlyFetchingProjects && (!imagesWithProjects || imagesWithProjects.filter((item) => !item.archived).length === 0) && (
              <NoProjectsFound />
            )
          }
          { isCurrentlyFetchingProjects && <ProjectsLoader numProjectsToShow={8} className="loader-additional-list" />}
          {galleryModal}
          <ArchivedProjectsGallery 
            projects={imagesWithProjects && imagesWithProjects.filter((item) => item.archived) || []}
            isImagesWithProjects={true}
          />
      </Styled.ImagesWithProjectsListContainer>
    </>
   )
}